module.exports = __webpack_public_path__ + "static/img/68.3281c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Teams/68.png
// module id = zkTK
// module chunks = 1